export default "__VITE_ASSET__d3ab24af__"